'use client';
import { useState } from 'react';
import QuestionForm from './QuestionForm';
import Question from './Question';
import ArrowTop from '@/app/_components/ui/icons/ArrowTop.svg';

export default function Questions({ questions, productId }) {
  const [openAskModal, setOpenAksModal] = useState(false);
  const [closeSection, setCloseSection] = useState(false);
  const onCloseAskModal = () => {
    setOpenAksModal(false);
  };

  return (
    <>
      <div
        className="spAskAnswer mt-3  md:mt-8 md:p-8 p-0  bg-white"
        id="spAskAnswer"
      >
        <div className="flex md:pb-10 md:pt-0 p-4 justify-between border-b border-light-gray-300 md:border-none">
          <h2 className="spNavTitle text-gray-500 text-sm md:text-base font-bold  ">
            پرسش و پاسخ
          </h2>
          <div
            className="md:hidden"
            onClick={() => setCloseSection((prev) => !prev)}
          >
            <ArrowTop className={`${closeSection && 'rotate-180'}`} />
          </div>
        </div>

        <div
          className={`${
            closeSection
              ? 'mt-0 p-0 h-0 overflow-hidden '
              : 'p-2 md:p-0 mt-4 md:mt-0 '
          }`}
        >
          <div className="max-w-[1074px] mx-auto">
            <div className="md:flex justify-between items-center pb-10">
              <div className=" md:text-base text-sm">
                کارشناسان ما آماده پاسخگویی به پرسش‌های شما هستند
              </div>
              <button
                className="text-color-primary hover:bg-color-primary transition hover:text-white border border-color-primary py-2.5 flex mt-4 md:mt-0 justify-center font-bold md:py-3 rounded-md w-full  mx-w-full md:w-[305px]"
                onClick={() => setOpenAksModal(true)}
              >
                ثبت پرسش
              </button>
            </div>

            {questions && questions?.data.length > 0 && (
              <>
                <div className="askAnswerSort flex md:justify-start justify-between items-center md:pb-4 border-b border-light-gray-300">
                  <div className=" text-sm font-bold text-gray-500 ">
                    {questions.data.length}
                    پرسش ثبت شده است
                  </div>
                </div>
                <div className="questions md:text-sm text-xs">
                  {questions.data.map((question) => (
                    <Question question={question} />
                  ))}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      <QuestionForm
        openModal={openAskModal}
        onClose={onCloseAskModal}
        productId={productId}
      />
    </>
  );
}
